import { useMetersPerPixel } from 'app/agriculture/hooks/useHerdDragAndDrop/useMetersPerPixel';
import { useCallback } from 'react';
import { Cartesian3 } from 'cesium';
import { useEntities } from 'app/agriculture/queries/entities/useEntities';

const PADDOCK_SNAPPING_RADIUS = 45; // number of pixels
export function useClosestPaddockPosition() {
    const metersPerPixel = useMetersPerPixel();
    const paddocks = useEntities('Paddock');

    const closestPaddockPosition = useCallback(
        (mousePosition: Cartesian3) => {
            if (metersPerPixel == null) {
                return {
                    paddockId: undefined,
                    isWithinRange: false,
                    closestPaddockPole: undefined,
                };
            }

            const [closestPole] = Array.from(paddocks)
                .map(([id, { pole }]) => {
                    const cartesianPole = Cartesian3.fromDegrees(...pole.coordinates);
                    const distance = Cartesian3.distance(mousePosition, cartesianPole);
                    return { cartesianPole, distance, id };
                })
                .sort((a, b) => a.distance - b.distance); // Get the closest pole

            if (closestPole == null) {
                return {
                    paddockId: undefined,
                    isWithinRange: false,
                    closestPaddockPole: undefined,
                };
            }

            const distancePixels = closestPole.distance / metersPerPixel;

            return {
                closestPaddockPole: closestPole.cartesianPole,
                paddockId: closestPole.id,
                isWithinRange: distancePixels < PADDOCK_SNAPPING_RADIUS,
            };
        },
        [metersPerPixel, paddocks],
    );

    return { closestPaddockPosition };
}
